export default __webpack_public_path__ + "static/media/distance.bea51cc7.svg";